import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sb-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class SbCardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
